import createTheme from '@mui/material/styles/createTheme'
import MuiThemeProvider from '@mui/material/styles/ThemeProvider'

import { PG, SLR, SDB } from '../../colors'

const mui = createTheme({
  typography: {
    fontFamily: "proxima-nova, 'Proxima Nova', 'Montseratt', sans-serif"
  },
  palette: {
    primary: {
      main: PG
    },
    secondary: {
      main: SDB
    },
    error: {
      main: SLR
    }
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: false
      }
    }
  }
})
const ThemeProvider = ({ children }) => {
  return <MuiThemeProvider theme={mui}>{children}</MuiThemeProvider>
}

export { ThemeProvider }
